export default __webpack_public_path__ + "static/media/closeWhite.266f3696.svg";